import { render, staticRenderFns } from "./IndemnityDetails.vue?vue&type=template&id=8c6158f6&scoped=true"
import script from "./IndemnityDetails.vue?vue&type=script&lang=js"
export * from "./IndemnityDetails.vue?vue&type=script&lang=js"
import style0 from "./IndemnityDetails.vue?vue&type=style&index=0&id=8c6158f6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6158f6",
  null
  
)

export default component.exports